module.exports = __webpack_public_path__ + "static/media/tool3.b300cb55.svg";